import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { BackupStationSet, Station, StationGroup, StationSet } from '../model/yard-structure.model';

@Injectable({
  providedIn: 'root'
})

export class StationgroupService {
  constructor(private appServerAPI: AppServerAPI) { }

  getStationGroups(): Observable<StationGroup[]> {
    return this.appServerAPI.execute<StationGroup[]>('/client/admin/stationgroups/stationgroups', {});
  }

  getStations(): Observable<Station[]> {
    return this.appServerAPI.execute<Station[]>('/client/admin/stationgroups/stations', {});
  }

  getBackupStationSets(): Observable<BackupStationSet[]> {
    return this.appServerAPI.execute<BackupStationSet[]>('/client/admin/stationgroups/backup-station-sets', {});
  }

  saveStationGroups(stationGroups: StationGroup[]): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/stationgroups/save', stationGroups);
  }

  validateStationSetDeletion(stationSet: StationSet): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/stationgroups/stationsets/validatedelete', stationSet);
  }
}
